import { FC, useEffect, useState } from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    OutlinedInput,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Gateway from 'types/gateway';

interface ChildComponentProps {
    gateway?: Gateway;
    onAdd(gateway: Gateway): any;
    onClose(): any;
}

const GatewayAdd: FC<ChildComponentProps> = (props) => {
    const { gateway, onAdd, onClose } = props;
    const [open, setOpen] = useState(false);
    const [currentGateway, setCurrentGateway] = useState(gateway);
    const { t } = useTranslation();
    const theme = useTheme();
    const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        if (gateway === undefined) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [gateway]);

    return (
        <>
            <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title"> {t('ADD_NEW_GATEWAY')} </DialogTitle>
                <DialogContent sx={{ paddingTop: '6px!important', width: mobileDevice ? window.innerWidth - 65 : 500 }}>
                    <Grid container>
                        <Grid item md={8} xs={12} sx={{ mb: 2 }}>
                            <FormControl fullWidth required>
                                <InputLabel>{t('NAME')}</InputLabel>
                                <OutlinedInput
                                    defaultValue={currentGateway?.name}
                                    onChange={(d) => {
                                        const e = {
                                            ...currentGateway!,
                                            name: d.target.value
                                        };
                                        setCurrentGateway(e);
                                    }}
                                    type="text"
                                    label={t('NAME')}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12} sx={{ mb: 2, textAlign: 'center' }}>
                            <FormControl fullWidth>
                                <>{t('MAINTENANCE_MODE')}</>
                                <Checkbox
                                    checked={currentGateway?.maintenanceMode!}
                                    onChange={(d) => {
                                        const e = {
                                            ...currentGateway!,
                                            maintenanceMode: d.target.checked
                                        };

                                        setCurrentGateway(e);
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Typography marginTop="5px"> * {t('MANDATORY_FIELDS')}</Typography>
                </DialogContent>
                <DialogActions sx={{ marginRight: '16px' }}>
                    <Button
                        onClick={() => {
                            setCurrentGateway(undefined);
                            onClose();
                        }}
                        autoFocus
                        style={{
                            border: '2px solid',
                            borderColor: theme.palette.secondary.main,
                            borderRadius: 7
                        }}
                    >
                        <Typography sx={{ color: theme.palette.primary.main }}> {t('CANCEL')}</Typography>
                    </Button>
                    <Button
                        style={{
                            border: '2px solid',
                            borderColor: theme.palette.primary.main,
                            borderRadius: 7,
                            background: theme.palette.primary.main
                        }}
                        onClick={() => {
                            onAdd(currentGateway!);
                        }}
                    >
                        <Typography style={{ color: '#fff' }}>{t('ADD')}</Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default GatewayAdd;
